module.exports = __webpack_public_path__ + "07_mole.1ffdf867.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/07_mole.png
// module id = 6tmJ
// module chunks = 0